import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private readonly refreshTokenKey = 'refreshToken';
  private readonly loginRefreshTokenKey = 'loginRefreshToken';

  private readonly isRefreshTokenValidSubject = new BehaviorSubject<boolean>(this.isRefreshTokenValid());
  isRefreshTokenValid$ = this.isRefreshTokenValidSubject.asObservable();

  private readonly isEveportalJwtTokenValidSubject = new BehaviorSubject<boolean>(this.isEveportalJwtTokenValid());
  isEveportalJwtTokenValid$ = this.isEveportalJwtTokenValidSubject.asObservable();

  constructor() {}

  getRefreshToken(): string | null {
    return localStorage.getItem(this.refreshTokenKey);
  }
  
  getEveportalJwtToken(): string | null {
     const loginResult = this.getLoginRefreshToken();
     if(!!loginResult) {
       return loginResult.jwt;
     }
     return null;
  }

  getLoginRefreshToken(): any {
    const loginResultString = localStorage.getItem(this.loginRefreshTokenKey);
    if (!!loginResultString) {
      return JSON.parse(loginResultString);
    } else {
      return null;
    }
  }

  setRefreshToken(token: string): void {
    localStorage.setItem(this.refreshTokenKey, token);
    this.isRefreshTokenValidSubject.next(this.isRefreshTokenValid());
  }

  setLoginRefreshToken(loginResult: any) {
    localStorage.setItem(this.loginRefreshTokenKey, JSON.stringify(loginResult));
    this.isEveportalJwtTokenValidSubject.next(this.isEveportalJwtTokenValid());
  }

  clearRefreshToken(): void {
    localStorage.removeItem(this.refreshTokenKey);
  }

  clearAllTokens(): void {
    localStorage.removeItem(this.refreshTokenKey);
    localStorage.removeItem(this.loginRefreshTokenKey);

    this.isRefreshTokenValidSubject.next(false);
    this.isEveportalJwtTokenValidSubject.next(false);
  }

  isRefreshTokenValid(): boolean {
    const token = this.getRefreshToken();
    return token !== null && !this.isTokenExpired(token);
  }

  isEveportalJwtTokenValid(): boolean {
    const token = this.getEveportalJwtToken();
    return token !== null && !this.isTokenExpired(token);
  }

  getJwtTokenPayload(): any {
    const token = this.getEveportalJwtToken();
    if (!token) return null;

    try {
      return JSON.parse(atob(token.split('.')[1]));
    } catch (error) {
      console.warn('❌ Failed to decode JWT token payload:', error);
      return null;
    }
  }

   // === Token Validation ===

   private isTokenExpired(token: string | null): boolean {
    if (!token) return true;
    const expiry = this.getTokenExpiration(token);
    if (!expiry) return true;

    const now = Math.floor(Date.now() / 1000);
    return expiry <= now;
  }

  // === Helper to decode the token ===

  private getTokenExpiration(token: string): number | null {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.exp;
    } catch (error) {
      console.warn('❌ Failed to decode token expiration:', error);
      return null;
    }
  }


}
